export default {"src":"/_next/static/media/outdoor_24.92b357dc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};